import { useOptionalClientPortalBootstrap } from "../../providers/clientPortalBootstrapContext";
import { RegionEntitlementSignUpForm } from "../../components/RegionEntitlementSignUpForm";

interface Props {
  onClose: () => void;
}

export function SignUpRegionPage(props: Props) {
  const { onClose } = props;
  const bootstrap = useOptionalClientPortalBootstrap();

  return (
    <RegionEntitlementSignUpForm
      onClose={onClose}
      onSuccess={async () => {
        await bootstrap?.mutateUser()?.catch(() => undefined);
      }}
    />
  );
}
